module.exports = __webpack_public_path__ + "static/media/02.c795ee50.jpg";